import { render, staticRenderFns } from "./MainLeftBlock.vue?vue&type=template&id=03272c0a&scoped=true&"
import script from "./MainLeftBlock.vue?vue&type=script&lang=js&"
export * from "./MainLeftBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainLeftBlock.vue?vue&type=style&index=0&id=03272c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03272c0a",
  null
  
)

export default component.exports